import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import { FlexView, List, Text } from '@cuemath/comps';

import { CenterText as HeaderText } from 'comps/styled-text';
import Worksheet from './worksheet';

export default class BlockContent extends PureComponent {
  static propTypes = {
    blockContent: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  keyExtractor = content => (content.lesson ? content.lesson.id : content.homework.id);

  renderItem = ({ item: blockContent }) => {
    const { match } = this.props;

    return (
      <Worksheet
        worksheet={blockContent.lesson ? blockContent.lesson : blockContent.homework}
        match={match}
      />
    );
  };

  render() {
    const { blockContent, match } = this.props;
    return (
      <FlexView>
        <HeaderText> Lessons and Homeworks </HeaderText>
        {blockContent.length ? (
          <List
            match={match}
            data={blockContent}
            keyExtractor={this.keyExtractor}
            renderItem={this.renderItem}
          />
        ) : (
          <Text align="center"> No Worksheets Present</Text>
        )}
      </FlexView>
    );
  }
}
